module.exports = __webpack_public_path__ + "img/elevator_big_opening.f5afed75.gif";